import { mainAxios } from '@/plugins/axios';

class importStockItemService {
  async upload(data, config) {
    return await mainAxios.post(`/importacao-estoque/importar`, data, config);
  }

  async latest(url) {
    let response = await mainAxios.get(url);
    return response.data;
  }

  async latestQueue() {
    let response = await mainAxios.get('/importacao-estoque/queue-init');
    return response.data;
  }

  async closed() {
    let response = await mainAxios.get('/importacao-estoque/concluidos');
    return response.data;
  }

  async create() {
    let response = await mainAxios.post(`/estoque-movimentacoes/atualizar`);
    return response.data;
  }

  async createNew(payload) {
    let response = await mainAxios.post(`/estoque-movimentacoes/movimentacao`, payload);
    return response.data;
  }
}

export default new importStockItemService();
